import React, { Component } from 'react';
import PropTypes from 'prop-types';

class FormRadio extends Component {
  onChange(event) {
    this.props.onChange(event.target.value);
  }
  isSelectedOption(value) {
    return this.props.value === value;
  }
  render() {
    let name = this.props.name;
    return (
      <div className={`radio ${this.props.errorClassStyle}`}>
        {this.props.options.map((option, i) => {
          return (
            <div key={'radio' + i}>
              <label>
                <span className="m-r-xs">
                  <input
                    type="radio" name={name}
                    onChange={(event) => this.onChange(event)}
                    value={option[0]}
                    style={{...this.props.style}}
                    checked={this.isSelectedOption(option[0])}
                  />
                </span> {option[0]}
              </label>
            </div>
          )
        }, this)}
      </div>
    );
  }
}

FormRadio.propTypes = {
  name: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
    classStyle: PropTypes.string,
    value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  onChange: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool
};

export default FormRadio;